<template>
  <div class="w-full h-24 flex items-end justify-center p-2">
    <div
      class="w-full h-full mr-px xl:mr-1 last:mr-0 relative bg-gray-300 flex items-end relative group"
      v-for="(entry, index) in entries"
      :key="index"
    >
      <transition name="expand">
        <div
          :style="{height: getPercentage(entry)}"
          class="w-full"
          :class="[css ? css : 'bg-blue-500']"
          v-if="animationStart"
        />
      </transition>
      <div
        class="absolute hidden group-hover:block z-10 top-0 right-0 px-3 py-1 rounded-bl-lg bg-white shadow-lg font-bold text-sm opacity-75"
      >
        <p>{{ entry }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatisticsBar",
  data() {
    return {
      max: 0,
      animationStart: false
    };
  },
  props: {
    entries: {
      required: true,
      type: Array
    },
    css: {
      type: String
    }
  },
  components: {},
  methods: {
    getPercentage(Value) {
      return Value !== 0 ? (Value / this.max) * 100 + "%" : 0;
    }
  },
  computed: {},
  created() {
    this.max = Math.max(...this.entries);
    setTimeout(() => {
      this.animationStart = true;
    }, 50);
  }
};
</script>